import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { getAllAwards } from "../../api/award.api";
import { getActiveEvent } from "../../api/event.api";

const AssignAwardModal = ({ open, handleClose, handleSubmit }) => {
  const [event, setEvent] = useState();
  const [awards, setAwards] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    id: "",
  });

  const initialFormData = {
    name: "",
    id: "",
  };

  useEffect(() => {
    getActiveEvent().then((response) => {
      setEvent(response.data);
    });
    getAllAwards()
      .then((response) => setAwards(response.data))
      .catch((error) => console.log(error));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
    setFormData(initialFormData);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">Assign Award</Typography>
          <div>
            {event &&
              <FormControl fullWidth>
                <InputLabel id="select-category-label">Award</InputLabel>
                <Select
                  labelId="select-category-label"
                  id="award"
                  name="id"
                  value={formData.id}
                  label="Award"
                  onChange={handleChange}
                >
                  {awards.filter(award => award.eventId === undefined || award.eventId === event.id).map((award) => (
                    <MenuItem key={award.id} value={award.id}>
                      {award.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            }
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignAwardModal;
